import { render, staticRenderFns } from "./CapsuleProgress.vue?vue&type=template&id=704f58b1&"
import script from "./CapsuleProgress.vue?vue&type=script&lang=js&"
export * from "./CapsuleProgress.vue?vue&type=script&lang=js&"
import style0 from "./CapsuleProgress.vue?vue&type=style&index=0&id=704f58b1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports